import React, {Fragment, PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Badge from '@spothero/ui/badge';
import Button from '@spothero/ui/button';
import Select from '@spothero/ui/select';
import Icon from 'common/icon/Icon';
import {
    setSortType,
    toggleListView,
    toggleFiltersView
} from '../search-actions';

class SpotListAvailabilityDesktop extends PureComponent {
    static propTypes = {
        onListToggle: PropTypes.func.isRequired,
        isFetchComplete: PropTypes.bool.isRequired,
        numSpots: PropTypes.number.isRequired,
        numActiveFilters: PropTypes.number.isRequired,
        onChangeSort: PropTypes.func.isRequired,
        onFilterSpotsToggle: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this._sortSelectItems = [
            {value: 'distance', label: 'Distance'},
            {value: 'price', label: 'Price'}
        ];
    }

    _onSelectChange = ({value}) => {
        this.props.onChangeSort(value);
    }

    render() {
        const {
            numActiveFilters,
            numSpots,
            isFetchComplete,
            onListToggle,
            onFilterSpotsToggle
        } = this.props;
        const hasFilters = (numActiveFilters > 0);
        const badgeLabel = (hasFilters) ? numActiveFilters.toString() : null;

        return (
            <div className="SpotListAvailability">
                <Button
                    className="SpotListAvailability-list-toggle"
                    color="secondary"
                    onClick={onListToggle}
                >
                    <Icon name="chevron-double-left" />
                </Button>
                {((isFetchComplete && numSpots > 0) || !isFetchComplete) &&
                    <Fragment>
                        <div className="availability">
                            <small>{numSpots} Spots Available</small>
                        </div>
                        <div className="sorting">
                            <Select
                                className="SpotListAvailability-filter-select"
                                onChange={this._onSelectChange}
                                items={this._sortSelectItems}
                            />
                            <Button
                                className="filter-results"
                                color="secondary"
                                onClick={onFilterSpotsToggle}
                            >
                                {(hasFilters) ? 'Edit Filters' : 'Filter Spots'}
                                {badgeLabel &&
                                    <Badge className="SpotListAvailability-filter-badge">{badgeLabel}</Badge>
                                }
                            </Button>
                        </div>
                    </Fragment>
                }
            </div>
        );
    }
}

const mapStateToProps = state => {
    const {
        filters: {
            numActive
        }
    } = state;

    return {
        numActiveFilters: numActive
    };
};

const mapDispatchToProps = {
    onChangeSort: setSortType,
    onListToggle: toggleListView,
    onFilterSpotsToggle: toggleFiltersView
};

export default connect(mapStateToProps, mapDispatchToProps)(SpotListAvailabilityDesktop);
